import React, { useState } from 'react';
import MyButton from './MyButton';
import { useNavigate } from 'react-router-dom';
import DiaryItem from './DiaryItem';

const sortOptionList = [
    { value: "lastest", name: "최신순" },
    { value: "oldest", name: "오래된 순" }
];

const filterOptionList = [
    { value: "all", name: "전부다" },
    { value: "good", name: "좋은 감정만" },
    { value: "bad", name: "안좋은 감정만" },
]

const ControlMenu = React.memo(({ value, setOnChange, optionList }) => {
    //console.log("ControlMenu");
    return <select
        className='ControlMenu'
        value={value} onChange={(e) => setOnChange(e.target.value)} >
        {
            optionList.map((it, idx) =>
                (<option key={idx} value={it.value}>{it.name}</option>))
        }
    </select>
})

const DiaryList = ({ diaryList }) => {
    const navigate = useNavigate();
    const [sortType, setSortType] = useState('lastest');
    const [filter, setFilter] = useState("all");


    const getProcessedDiaryList = () => {

        const filterCallBack = (item) => {
            if (filter === 'good') {
                return parseInt(item.emotion) <= 3;
            } else {
                return parseInt(item.emotion) > 3;
            }
        }

        //오래된순 &&  최신순
        const compare = (a, b) => {
            if (sortType === "lastest") {
                return parseInt(b.date) - parseInt(a.date);
            } else {
                return parseInt(a.date) - parseInt(b.date);
            }
        }
        const copyList = JSON.parse(JSON.stringify(diaryList));

        const filteredList = filter === 'all' ? copyList : copyList.filter((it) => filterCallBack(it));

        const sortList = filteredList.sort(compare);
        return sortList;
    }


    return (
        <div className='DiaryList'>
            <div className='menu_wrapper'>
                <div className="left_col">
                    <ControlMenu value={sortType} setOnChange={setSortType} optionList={sortOptionList} />
                    <ControlMenu value={filter} setOnChange={setFilter} optionList={filterOptionList} />
                </div>
                <div className="right_col">

                    <MyButton type={'positive'} text={"새읽기 쓰기"} onClick={() => navigate("/new")} />
                </div>
            </div>





            {getProcessedDiaryList() && getProcessedDiaryList().map((it) => (
                <DiaryItem key={it.id}  {...it} />
            ))}
        </div>
    );
};

DiaryList.defaultProps = {
    diaryList: [],
}
export default DiaryList;